/**
 * "The Syncanix CLI" overview — CLI section (ADR-0074).
 * Reconciled from packages/cli/src (cli.ts global options + command list).
 */
import type { DocPageContent } from '../types';

export const CLI_OVERVIEW_PAGE: DocPageContent = {
  slug: 'cli',
  titleKey: 'docs.cli.overview.title',
  descriptionKey: 'docs.cli.overview.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.cli.overview.lead' },

    { kind: 'heading', level: 2, id: 'install', textKey: 'docs.cli.overview.install.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.overview.install.body' },
    { kind: 'code', language: 'bash', code: 'npx syncanix@latest init' },
    { kind: 'paragraph', textKey: 'docs.cli.overview.install.node' },

    { kind: 'heading', level: 2, id: 'commands', textKey: 'docs.cli.overview.commands.heading' },
    {
      kind: 'definitions',
      variant: 'code',
      items: [
        { termKey: 'docs.cli.overview.cmd.init.term', descKey: 'docs.cli.overview.cmd.init.desc' },
        {
          termKey: 'docs.cli.overview.cmd.console.term',
          descKey: 'docs.cli.overview.cmd.console.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.generate.term',
          descKey: 'docs.cli.overview.cmd.generate.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.integrate.term',
          descKey: 'docs.cli.overview.cmd.integrate.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.status.term',
          descKey: 'docs.cli.overview.cmd.status.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.import.term',
          descKey: 'docs.cli.overview.cmd.import.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.login.term',
          descKey: 'docs.cli.overview.cmd.login.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.whoami.term',
          descKey: 'docs.cli.overview.cmd.whoami.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.workspace.term',
          descKey: 'docs.cli.overview.cmd.workspace.desc',
        },
        { termKey: 'docs.cli.overview.cmd.dev.term', descKey: 'docs.cli.overview.cmd.dev.desc' },
        {
          termKey: 'docs.cli.overview.cmd.doctor.term',
          descKey: 'docs.cli.overview.cmd.doctor.desc',
        },
        {
          termKey: 'docs.cli.overview.cmd.byomcp.term',
          descKey: 'docs.cli.overview.cmd.byomcp.desc',
        },
        { termKey: 'docs.cli.overview.cmd.yaml.term', descKey: 'docs.cli.overview.cmd.yaml.desc' },
        {
          termKey: 'docs.cli.overview.cmd.version.term',
          descKey: 'docs.cli.overview.cmd.version.desc',
        },
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'global-options',
      textKey: 'docs.cli.overview.global.heading',
    },
    {
      kind: 'definitions',
      variant: 'code',
      items: [
        {
          termKey: 'docs.cli.overview.global.version.term',
          descKey: 'docs.cli.overview.global.version.desc',
        },
        {
          termKey: 'docs.cli.overview.global.noColor.term',
          descKey: 'docs.cli.overview.global.noColor.desc',
        },
        {
          termKey: 'docs.cli.overview.global.locale.term',
          descKey: 'docs.cli.overview.global.locale.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.cli.overview.localized.title',
      textKey: 'docs.cli.overview.localized.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.cli.overview.next.init.title',
          textKey: 'docs.cli.overview.next.init.text',
          to: { docSlug: 'cli/init' },
        },
        {
          titleKey: 'docs.cli.overview.next.commands.title',
          textKey: 'docs.cli.overview.next.commands.text',
          to: { docSlug: 'cli/commands' },
        },
      ],
    },
  ],
};
